import data from "@iconify/icons-eva/more-vertical-fill";

// vi behöver använda en annan backend-url för att cookies ska fungera om siten använder adressen kortillstand.se
const getAuthBaseUrl = () =>
  window.global?.isKs ? import.meta.env.VITE_KORTILLSTAND_AUTH_URL : import.meta.env.VITE_AUTH_URL;

export function getBackendBaseUrl() {
  return window.global?.isKs ? import.meta.env.VITE_KORTILLSTAND_MAIN_URL : import.meta.env.VITE_MAIN_URL;
}

export async function getPermitForResponsibleView(actorPermitId, dataId) {
  const url = `${getBackendBaseUrl()}permits/responsible-view?actorPermitId=${actorPermitId}&dataId=${dataId}`;
  return get(url, onPermitResponsibleViewTokenExpired);
}

export async function getPermitsForResponsibleView(dataId) {
  let url = `${getBackendBaseUrl()}permits/responsible-view/all`;
  url += dataId ? `?dataId=${dataId}` : "";
  return get(url, onPermitResponsibleViewTokenExpired);
}

export async function getCompaniesForResponsibleView() {
  const url = `${getBackendBaseUrl()}permits/responsible-view/companies`;
  return get(url, onPermitResponsibleViewTokenExpired);
}

export async function sendNextSignerEmailForResponsibleView(actorPermitId, actorPermitGroupId, dataId) {
  const url = `${getBackendBaseUrl()}permits/responsible-view/email/next-signer?actorPermitGroupId=${actorPermitGroupId}&actorPermitId=${actorPermitId}&dataId=${dataId}`;
  return get(url, onPermitResponsibleViewTokenExpired);
}

export async function incativatePermitForResponsibleView(inactivationRequest) {
  const url = `${getBackendBaseUrl()}permits/responsible-view/inactivate`;
  return post(url, inactivationRequest, onPermitResponsibleViewTokenExpired);
}

export async function markPermitAsReviewedForResponsibleView(actorPermitGroupId, actorPermitId, dataId) {
  const url = `${getBackendBaseUrl()}permits/responsible-view/review?actorPermitGroupId=${actorPermitGroupId}&actorPermitId=${actorPermitId}&dataId=${dataId}`;
  return post(url, null, onPermitResponsibleViewTokenExpired);
}

export async function getPermitPdfBlobForResponsibleView(actorPermitId, dataId) {
  const url = `${getBackendBaseUrl()}permits/responsible-view/pdf?actorPermitId=${actorPermitId}&dataId=${dataId}`;
  return await getBlob(url, null, onPermitResponsibleViewTokenExpired);
}

export async function logoutForResponsibleView() {
  const url = `${getAuthBaseUrl()}auth/bankid/logout/permit-responsible-view`;
  return await post(url, null, onPermitResponsibleViewTokenExpired);
}

export async function getPermitGroup(actorPermitGroupId) {
  const url = `${getBackendBaseUrl()}permits/groups?actorPermitGroupId=${actorPermitGroupId}`;

  return get(url);
}

export function getHolderActorForResponsibleView(actorId, dataId) {
  return get(`${getBackendBaseUrl()}permits/responsible-view/holder/actor/${actorId}?dataId=${dataId}`);
}

export async function getSuggestedValuesForNewPermit(dataId, skillGroupId) {
  return get(`${getBackendBaseUrl()}permits/responsible-view/suggested-values/${skillGroupId}?dataId=${dataId}`);
}


export async function getSkillGroupsForNewPermit(dataId) {
  return get(`${getBackendBaseUrl()}permits/responsible-view/skillgroups/for-permits?dataId=${dataId}&includeImageUrls=true`);
}

export async function getActorSkillsForNewPermit(dataId, actorIds) {
  return get(`${getBackendBaseUrl()}permits/responsible-view/actors/skills/for-new-permit?dataId=${dataId}&actorIds=${actorIds?.join(",")}`);
}

export async function getParentActorForNewActor(dataId) {
  return get(`${getBackendBaseUrl()}permits/responsible-view/actors/parent-actor/for-data-id?dataId=${dataId}`);
}

export async function getOrgNoFormats(dataId) {
  return get(`${getBackendBaseUrl()}permits/responsible-view/getOrgNoFormats?dataId=${dataId}`);
}

export async function postActorSerarch(dataId, actorSearchRequest) {
  return post(`${getBackendBaseUrl()}permits/responsible-view/actors/search/full?dataId=${dataId}`, actorSearchRequest);
}

export async function postActorPermitGroupForResponsibleView(dataId, permitGroup) {
  return post(`${getBackendBaseUrl()}permits/responsible-view/groups?dataId=${dataId}`, permitGroup);
}

export async function getEmailResponsible(dataId, actorPermitGroupId) {
  return get(`${getBackendBaseUrl()}permits/responsible-view/groups/email?actorPermitGroupId=${actorPermitGroupId}&dataId=${dataId}&ignoreFailResponse=true`);
}

export async function postActorForResponsibleView(dataId, parentActorId, actor) {
  return post(`${getBackendBaseUrl()}permits/responsible-view/actors/${parentActorId}/students?dataId=${dataId}`, actor);
}

export function updateHolderActorElectronicContactsForResponsibleView(actorElectronicContactsDto) {
  return post(`${getBackendBaseUrl()}permits/responsible-view/holder/electronic-contacts`, actorElectronicContactsDto);
}

export function getHolderActor(actorId) {
  return get(`${getBackendBaseUrl()}permits/holder/actor/${actorId}`);
}

export function updateHolderActorElectronicContacts(actorElectronicContactsDto) {
  return post(`${getBackendBaseUrl()}permits/holder/electronic-contacts`, actorElectronicContactsDto);
}

export async function getPermit(actorPermitId) {
  const url = `${getBackendBaseUrl()}permits?actorPermitId=${actorPermitId}`;
  return get(url);
}

export async function signPermitGroup(actorPermitGroupId, isMobile) {
  return post(`${getBackendBaseUrl()}permits/groups/sign`, {
    actorPermitGroupId: actorPermitGroupId,
    autoStartUrlFormatForMobileDevice: isMobile,
  });
}

export async function signPermit(actorPermitId, isMobile) {
  return post(`${getBackendBaseUrl()}permits/sign`, {
    actorPermitId: actorPermitId,
    autoStartUrlFormatForMobileDevice: isMobile,
  });
}

export async function getPermitPdfBlob(actorPermitId) {
  const url = `${getBackendBaseUrl()}permits/pdf?actorPermitId=${actorPermitId}`;
  return await getBlob(url);
}

export async function doDeletePermit(actorPermitId, message) {
  const url = `${getBackendBaseUrl()}permits/${actorPermitId}/for-responsible?message=${encodeURIComponent(message)}`;
  return await performDelete(url);
}

export async function getDataIdDetails() {
  const url = `${getBackendBaseUrl()}dataId/details/for-permit-sign`;
  return await get(url);
}

export async function getLogoDataUrl() {
  const url = `${getBackendBaseUrl()}dataIds/blobs/logo/dataUrl/for-permit-sign`;
  return await get(url);
}

export async function logout() {
  const url = `${getAuthBaseUrl()}auth/bankid/logout/permit-sign`;
  return await post(url, null);
}

async function get(url, onTokenExpired) {
  return fetch(url, {
    method: "GET",
    credentials: "include",
  })
    .then((response) => {
      if (response.ok) {
        return response.json();
      } else {
        if (response.status === 401 && onTokenExpired) {
          onTokenExpired();
        }
        const errorMessageTranslationKey = response.status === 401 ? "logInAgain" : "";
        return { isSuccessful: false, errorMessageTranslationKey };
      }
    })
    .catch({ isSuccessful: false });
}

async function post(url, requestBodyObject, onTokenExpired) {
  return fetch(url, {
    method: "POST",
    credentials: "include",
    headers: {
      "Content-Type": "application/json",
    },
    body: requestBodyObject ? JSON.stringify(requestBodyObject) : undefined,
  })
    .then((response) => {
      if (response.ok) {
        return response.json();
      } else {
        if (response.status === 401 && onTokenExpired) {
          onTokenExpired();
        }
        const errorMessageTranslationKey = response.status === 401 ? "logInAgain" : "";
        return { isSuccessful: false, errorMessageTranslationKey };
      }
    })
    .catch({ isSuccessful: false });
}

async function performDelete(url, requestBodyObject, onTokenExpired) {
  return fetch(url, {
    method: "DELETE",
    credentials: "include",
    headers: {
      "Content-Type": "application/json",
    },
    body: requestBodyObject ? JSON.stringify(requestBodyObject) : undefined,
  })
    .then((response) => {
      if (response.ok) {
        return response.json();
      } else {
        if (response.status === 401 && onTokenExpired) {
          onTokenExpired();
        }
        const errorMessageTranslationKey = response.status === 401 ? "logInAgain" : "";
        return { isSuccessful: false, errorMessageTranslationKey };
      }
    })
    .catch({ isSuccessful: false });
}

async function getBlob(url, options, onTokenExpired) {
  return fetch(url, {
    method: "GET",
    credentials: "include",
  })
    .then((response) => {
      if (response.ok) {
        return response.blob();
      } else {
        if (response.status === 401 && onTokenExpired) {
          onTokenExpired();
        }
        const errorMessageTranslationKey = response.status === 401 ? "logInAgain" : "";
        return { isSuccessful: false, errorMessageTranslationKey };
      }
    })
    .catch({ isSuccessful: false });
}

function onPermitResponsibleViewTokenExpired() {
  window.location = "/login/permit-responsible-view?timeout=1";
}
